<template>
  <FormProduct />
</template>

<script>
import FormProduct from '@/components/Form/Product'
export default {
  components: {
    FormProduct,
  },
  theme() {
    return {
      title: 'Ajouter un nouveau produit',
      subtitle: '',
    }
  },
}
</script>

<style></style>
